
import { ProductFormState } from '../types';
import { DEFAULT_BENEFITS, DEFAULT_FAQS } from '../product-save/defaults';

// Default product state for new products
export const DEFAULT_PRODUCT_STATE: ProductFormState = {
  product: null,
  showSummary: false,
  name: '',
  overview: '',
  description: '',
  price: '',
  discountPrice: '',
  sku: '',
  quantity: 0,
  initialQuantity: 0,
  lowStockThreshold: 5,
  isOutOfStock: false,
  isStockManaged: true,
  mediaUrls: [],
  category: '',
  benefits: DEFAULT_BENEFITS,
  faqs: DEFAULT_FAQS,
  weight: '',
  dimensions: { length: 0, width: 0, height: 0 },
  tags: [],
  isVisible: true,
  status: 'draft',
  currency: 'DZD',
  shopId: '',
  formId: null,
  organizationId: null
};
